module.exports = __webpack_public_path__ + "static/media/Uniserved-Logo-square-for-light-bg.b42c3f94.png";